<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1OH7kK/tc-custom/9781608081738.jpg?1692012984963" alt="This image is the cover for the book These Are My People"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">These Are My People
      </h1>
      <p class="bookDescription body article font2">
        <p>What would it be like to be a part of country music history? Singer/sngwriter and manager Merle Kilgore could have told you. He awed his fans with tales of his life in the music business, always with a supporting cast of impossibly famous friends. At age fourteen Merle carried the guitar for Hank Williams Sr. Four years later he wrote his first song, and Webb Pierce turned it into a million-seller. He double-dated with Elvis Presley, wrecked hotel rooms with Johnny Cash, held seances with Johnny Horton, and convinced Audrey Williams to put Hank Jr. on the road at fourteen-years-old. Merle became a prolific songwriter, entering the Nashville Songwriters Hall of Fame. He co-wrote his signature accomplishment, Ring of Fire with June Carter Cash. This work is listed by CMT as one of the top four all-time country music songs. These are just a few of the amazing stories of Merle's life, showcased in These Are My People, written by his grandson Mark Rickert.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Rickert
      </h2>
      
      <p class="authorDescription body article">Mark Rickert grew up in a country music household, just a few miles from the Opryland USA Theme Park and the Grand Ole Opry, and only a block from the home of Colonel Tom Parker, Elvis Presley's manager. Mark's father even worked as a Nashville tour guide. But it was his grandfather Merle Kilgore who showed him backstoage to the business. Before publishing his first novel, The Tone Poet, Mark served eight years as a photo-journalist for the US Army Reserve, spending a year of that service in Baghdad, Iraq, writing for military publications. In 2008 he earned a Master's in English Literature from Middle Tennessee State University. Today, he works as chief of public affairs for an Army recruiting battalion. Mark lives in Annapolis, Maryland with his wife and two children. These Are My People is his second book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d946c70